import VContainer from './VContainer.vue';

export { VContainer };
export default VContainer;
